import { backColor as backColor_1 } from './backColor.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { RibbonButton, RibbonDropDownProps } from './RibbonButton';

import { ColorPicker, backColors } from 'owa-color-picker';
import { setBackgroundColor } from 'roosterjs-editor-api';

const backColor: RibbonButton = {
    key: 'backColor',
    title: () => loc(backColor_1),
    imageSrc: require('../svg/backcolor.svg'),
    createDropDownCallback: React.memo(
        ({ target, plugin, dismiss, logUsage }: RibbonDropDownProps) => {
            const onSelect = React.useCallback(color => {
                const editor = plugin.getEditor();
                setBackgroundColor(editor, color.colorCode);
                logUsage('setBackgroundColor', [
                    color.colorCode.lightModeColor,
                    editor.isDarkMode(),
                ]);
            }, []);
            return (
                <ColorPicker
                    menuTargetElement={target}
                    onDismissMenu={dismiss}
                    colors={backColors.get()}
                    onSelectColor={onSelect}
                    shouldFocusOnMount={true}
                    selectedColor={plugin.getFormatState().backgroundColor}
                />
            );
        }
    ),
};

export default backColor;
